














/* Created- 04 - Apr - 2019 */
import { Component, Vue, Prop } from "vue-property-decorator";
import { eParticaAction, ParticaEvent } from "../../../Models/ParticaEvent";
@Component(
	{
		name: "ArticleInstagram"
	})
export default class ArticleInstagram extends Vue {
	@Prop() private instagram: string;
	private changed(event: any) {
		this.$emit("update:instagram", event);
		this.$emit("partica-event", { action: eParticaAction.PROPERTY_CHANGED } as ParticaEvent);
	}

}
